import { Component, OnInit, inject } from '@angular/core';
import { ConfigurationFacade } from '../../facades/configuration.facade';
import { IStoreAddress } from '../../models/settings.model';
import { AppUtils } from '../../utils/app.utils';
import { EStoreTypes } from '../../configurations/common';
import { UtilsService } from '../../services/utils.service';
import { take } from 'rxjs/operators';
import { skipWhile } from 'rxjs';
import { FooterFacade } from '../../facades/footer.facade';
import { IFooterNode } from '../../models/footer.models';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent implements OnInit {
  links: IFooterNode[] = [];
  storeAddress!: IStoreAddress;
  phone!: string;
  email!: string;
  phoneNumberFormat!: string;
  isUsStore: boolean = false;
  isCaStore: boolean = false;
  isInStore: boolean = false;
  emailGrievancesOfficer!: string;
  prefix!: string;
  delimiter!: string;
  taxId!: string;

  private readonly configFacade: ConfigurationFacade = inject(ConfigurationFacade);
  private readonly utils: UtilsService = inject(UtilsService);
  private readonly footerFacade: FooterFacade = inject(FooterFacade);

  ngOnInit(): void {
    this.getNavigation();
    this.getStoreAddressInfo();
    this.isUsStore = AppUtils.isStoreActive(EStoreTypes.US);
    this.isCaStore = AppUtils.isStoreActive(EStoreTypes.CA);
    this.isInStore = AppUtils.isStoreActive(EStoreTypes.IN);
    this.emailGrievancesOfficer = AppUtils.getCurrentStore().emailGrievancesOfficer || '';
    this.utils.getCustomRouteData();
  }

  /**
   * Get the store address information
   * @private
   */
  private getStoreAddressInfo(): void {
    this.storeAddress = this.configFacade.getCurrentStoreAddress()!;
    if (this.storeAddress) {
      this.phone = this.storeAddress.phoneNumber!;
      this.email = this.storeAddress.emailAddress!;
      this.phoneNumberFormat = this.storeAddress.phoneNumberFormat!;
      this.prefix = this.storeAddress.prefix!;
      this.delimiter = this.storeAddress.delimiter!;
      this.taxId = this.storeAddress.taxId!;
    }
  }

  /**
   * Get the store address
   * @returns {string}
   */
  public getAddress(): string {
    if (this.storeAddress) {
      const address1: string = this.storeAddress.address1 || '';
      const address2: string = this.storeAddress.address2 || '';
      const address3: string = this.storeAddress.address3 || '';
      return `${this.storeAddress.companyName} ${address1}${address2}${address3}`;
    }
    return '';
  }

  /**
   * Get the footer navigation
   * @returns {void}
   */
  public getNavigation(): void {
    this.footerFacade.selectFooterNavigation().pipe(
      skipWhile(footer => !footer),
      take(1),
    ).subscribe(footer => {
      if (!footer) {
        return;
      }
      this.links = footer.data.attributes.nodes.filter(node => node.isActive);
    });
  }

  /**
   * Hide social media footer
   * @returns {boolean}
   */
  hideSocialMedia(): boolean {
    return !!this.utils.customData['hideSocialMedia'];
  }

  /**
   * Show extended contact us section for US and CA stores
   * @returns {boolean}
   */
  showExtendedContactUs(): boolean {
    return this.isUsStore || this.isCaStore;
  }
}
